var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Chip } from "@mui/material";
import { cloneElement } from "react";
import { CommonThemeColors } from "./theme";
export var CChip = function (props) {
    var icon = props.icon ? cloneElement(props.icon, {
        sx: {
            fontSize: '13px',
            color: '#fff'
        }
    }) : undefined;
    return (_jsx(Chip, __assign({ size: 'small' }, props, { icon: icon ? _jsx(Avatar, __assign({ sx: __assign({ width: 18, height: 18 }, props.styles) }, { children: icon })) : undefined, sx: __assign({ backgroundColor: props.disabled ? CommonThemeColors.sys.palette.blueGray["50"] : CommonThemeColors.sys.action.focus, "& .MuiChip-label": {
                marginTop: "2px",
            } }, props.sx) })));
};
